const envTest = window.__env || {};

// this is whatever your component edge war is called, with a trailing slash
envTest.baseUrl = 'component-edge/';
// whether to enable the Angular debugging provider
envTest.enableDebug = false;
envTest.language = 'ENGLISH';
envTest.dev = true;

envTest.intellidataApiUrl = 'https://stagesearch.kemet.com/intellidata/';
envTest.documentationUrl = 'https://stagesearch.kemet.com/component-documentation/';
envTest.datasheetUrl = 'https://stagesearch.kemet.com/datasheets/';
envTest.visualSearchFreshness = '05-15-2020'; // this is a time stamp to automatically expire the new badge.
export default envTest;
